// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"9357":"1bd95b5a858d1212","23933":"61b4c9334f43ec3a","50000":"e8dec7efcdc6dc08","60957":"a6bb4d012f829128","96325":"431d3ac0624a38a3"}[chunkId] + ".css";
};